import { useState, useEffect, useCallback } from "react";
import { unlockAudio } from "../lib/audio";

const STORAGE_KEY = "bps_sound_enabled";

export function useSoundPref() {
  const [enabled, setEnabled] = useState(() => {
    if (typeof window === "undefined") return true;
    const v = window.localStorage.getItem(STORAGE_KEY);
    return v === null ? true : v === "1";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(STORAGE_KEY, enabled ? "1" : "0");
    }
  }, [enabled]);

  const setAndUnlock = useCallback((next) => {
    setEnabled(next);
    if (next) unlockAudio();
  }, []);

  return [enabled, setAndUnlock];
}
